import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DarkModeService {
  private storageKey = 'dark-mode-enabled';
  private darkModeEnabled = false;

  constructor() {
    const saved = localStorage.getItem(this.storageKey);
    this.darkModeEnabled = saved === 'true';
    this.applyThemeClass();
  }

  enableDarkMode(): void {
    this.darkModeEnabled = true;
    this.applyThemeClass();
    localStorage.setItem(this.storageKey, 'true');
  }

  disableDarkMode(): void {
    this.darkModeEnabled = false;
    this.applyThemeClass();
    localStorage.setItem(this.storageKey, 'false');
  }

  toggle(): void {
    if (this.darkModeEnabled) {
      this.disableDarkMode();
    } else {
      this.enableDarkMode();
    }
  }

  isDarkMode(): boolean {
    return this.darkModeEnabled;
  }

  private applyThemeClass(): void {
    if (typeof document === 'undefined') {
      return;
    }

    document.body.classList.toggle('app-dark-mode', this.darkModeEnabled);
  }
}